import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputComponent } from '../../common/components/form-components/input/input';
import { Dropdown } from '../../common/components/form-components/dropdown/dropdown';
import { CardModule } from 'primeng/card';
import { Button } from '../../common/components/form-components/button/button';
import { StepsModule } from 'primeng/steps';
import { CreateAccount } from '../create-account/create-account/create-account';
import { StepperModule } from 'primeng/stepper';
import { BusinessDetails } from '../business-details/business-details';
import { CreateTeam } from '../create-team/create-team';
import { CommonModule } from '@angular/common';
import { CarouselModule } from 'primeng/carousel';
import { TranslateService } from '../../i18n/translate.service';

@Component({
  selector: 'app-signup-page',
  imports: [CommonModule, CardModule, CreateAccount, StepperModule, BusinessDetails, CreateTeam, CarouselModule,],
  templateUrl: './signup-page.html',
  styleUrl: './signup-page.scss',
})
export class SignupPage {
  activatedCallback!: number;
  activeStep = 1;

  constructor(readonly i18n: TranslateService) {}

  goToStep(step: number) {
    this.activeStep = step;
  }
}
